import React from 'react'
import styles from './WahooFlow.scss'
import {S2DLayout} from '../../S2DLayout'
import {FancyCheckmark} from 'common/FancyCheckmark'
import {CreateAccountStep} from '../../CreateAccountStep'
import payoffImg from 'assets/images/send_to_device/payoff.svg'

export class WahooFlow extends React.PureComponent {
  render () {
    const {subtitle, selectedDevice, step, route, routeId, onPrev, onNext} = this.props
    const currentUser = window.rwgps && window.rwgps.config.currentUser

    if (!currentUser) {
      return <CreateAccountStep {...this.props} title='Send to ELEMNT/BOLT' selectedDevice={selectedDevice} />
    }

    return (
      <S2DLayout
        title='Send to ELEMNT/BOLT'
        subtitle={subtitle}
        onClickPrev={onPrev}
        onClickNext={step !== 5 ? onNext : () => { window.location.href = `/routes/${routeId}` }}
        nextText={step !== 5 ? 'Next' : 'Return to Route'}
        step={step}
        stepCount={5}>
        <div className={styles.WahooFlow}>
          {step === 2 && <Step2 routeName={route && route.name} />}
          {step === 3 && <Step3 />}
          {step === 4 && <Step4 />}
          {step === 5 && <Step5 />}
        </div>
      </S2DLayout>
    )
  }
}

const Step2 = ({routeName}) => (
  <div className={styles.instructions}>
    <p>{routeName && <span>"<strong>{routeName}</strong>"</span>} has been added to your pinned routes and is available for navigation with your Wahoo device</p>
    <FancyCheckmark />
  </div>
)

const Step3 = () => (
  <div className={styles.instructions}>
    <p>Download the <strong>Wahoo ELEMNT companion app</strong> to your phone.</p>
    <p>Once downloaded, open the Wahoo app and pair your Wahoo ELEMNT device with your phone.</p>
    <p>Next, link your Ride with GPS account within the Wahoo app using the <a target='_blank' href='https://ridewithgps.com/help/wahoo-elemnt#authorize-rwgps'>Linked Accounts</a> settings.</p>
    <div className={styles.centeredImg}>
      <img src='/images/routes/wahoo_app_badge.png' />
    </div>
  </div>
)

// worth testing: https://groups.google.com/forum/#!topic/wahoo-elemnt-users/GnJNTd2wJDY
// (pinned rides may break Ride Starred filter)
const Step4 = () => (
  <div className={styles.instructions}>
    <p>On your ELEMNT, bring up the <strong>Routes</strong> screen, and press the <strong>Sync</strong> button.</p>
    <p>Once syncing is complete, sort your synced routes by <strong>Starred</strong>, bringing starred routes to the top of your route list.</p>
    <p>Your route will be visible as a starred route in your route list. Select your route, and press Navigate to begin navigation.</p>
  </div>
)

const Step5 = () => (
  <div className={styles.instructions}>
    <p>After a brief warm up, your Wahoo ELEMNT will begin navigation.</p>
    <p>Enjoy your ride!</p>
    <div className={styles.centeredImg}>
      <img src={payoffImg} width='150' height='150' />
    </div>
  </div>
)
